export default __webpack_public_path__ + "static/media/n_z.a5ec0e1c.webp";